import { Layout } from 'antd';
import { ReactNode } from 'react';

import AppHeader from '../AppHeader';
import AnnounceBanner from '../AnnounceBanner/AnnounceBanner';

type Props = {
	children: ReactNode;
};

export default function MainLayout(props: Props) {
	const { children } = props;

	return (
		<Layout>
			<AppHeader />
			<AnnounceBanner />
			<Layout>{children}</Layout>
		</Layout>
	);
}
